export default "__VITE_ASSET__DtwAJOdM__"